import * as React from 'react'

import Fetch from '../common/api/Fetch'
import { HydraItemResponse } from '../common/api/hydra-types'
import { config } from './config'
import { FormRecordRouteProps, FormRecordRaw } from './types'

export const withPublicFormRecord = cmp => {
  const Cmp = cmp

  return class Inner extends React.Component<FormRecordRouteProps, {}> {
    render() {
      const id = parseInt(this.props.match.params.formRecordId, 10)
      const url = config.api.urls.show(id)
      return (
        <Fetch url={url}>
          {(data: HydraItemResponse<FormRecordRaw>, options) => {
            if (options.status === 404) {
              return <h2>Taki formularz nie został znaleziony</h2>
            }
            if (options.status === 500) {
              return <h2>Nie mogę pobrać danych formularza</h2>
            }
            const newData = Object.assign({}, data, {
              sendTo: JSON.parse(data.sendTo),
              formSpec: JSON.parse(data.formSpec),
            })
            return <Cmp formRecord={newData} {...this.props} />
          }}
        </Fetch>
      )
    }
  }
}
